export default function WhatsAppBtn() {
  return (
    <>
      <div className="whatsapp-icon-main">
        <a href="https://api.whatsapp.com/send?phone=919818112145" target="_blank">
          <img src="/assets/whatsapp/whatsapp-icon.png" alt="whatsapp" className="img-responsive" />
        </a>
      </div>
    </>
  )
}
